import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Hero from "../../components/hero/HeroLight";
import Index from "../../components/about/index";
import Address from "../../components/Address";
import Services from "../../components/services/index";
import Blog from "../../components/blog/BlogLight";
import Contact from "../../components/Contact";
import ContactEn from "../../components/ContactEn";
import { ScrollingProvider, Section } from 'react-scroll-section';
import Scrollspy from 'react-scrollspy';
import '@fortawesome/fontawesome-free/js/all.js';
import { useLanguage } from "../../context/LanguageContext";
import LanguageToggle from "../../components/LanguageToggle";
import AddressEn from "../../components/AddressFormEnglish";

const HomeLight = () => {
  const { language } = useLanguage();

  document.body.classList.add("light");

  const menuItem = [
    { icon: "fa-home", menuName: language === "hu" ? "Főoldal" : "Home" },
    { icon: "fa-user", menuName: language === "hu" ? "Magunkról" : "About Us" },
    { icon: "fa-briefcase", menuName: language === "hu" ? "Megoldásaink" : "Services" },
    { icon: "fa-envelope-open", menuName: language === "hu" ? "Kapcsolat" : "Contact" },
  ];

  const sections = menuItem.map(item => item.menuName);

  return (
    <ScrollingProvider>
      <div className="green">
        <div className="demo-sticker dark-grey-bg">
          <LanguageToggle />
        </div>

        <div className="header">
          <TabList className="icon-menu revealator-slideup revealator-once revealator-delay1">
            <Scrollspy items={sections} currentClassName="react-tabs__tab--selected">
              {menuItem.map((item, i) => (
                <a href={`#${item.menuName}`} key={i}>
                  <Tab className="icon-box">
                    <i className={`fas ${item.icon}`}></i>
                    <h2>{item.menuName}</h2>
                  </Tab>
                </a>
              ))}
            </Scrollspy>
          </TabList>
        </div>

        <div className="tab-panel_list">

          <Section id={sections[0]} className="mobile_margin">
            <div className="home">
              <div className="container-fluid main-container container-home p-0" data-aos="fade-up" data-aos-duration="1200">
                <div className="color-block d-none d-lg-block"></div>
                <Hero />
              </div>
            </div>
          </Section>

          <Section id={sections[1]} className="mobile_margin">
            <div className="about">
              <div data-aos="fade-up" data-aos-duration="1200">
                <div className="title-section text-left text-sm-center">
                  <h1>
                    {language === "hu" ? "Szakértő " : "Professional "}
                    <span>{language === "hu" ? "csapat" : "Team"}</span>
                  </h1>
                  <span className="title-bg">{menuItem[1].menuName}</span>
                </div>
                <Index />
              </div>
            </div>
          </Section>

          <Section id={sections[2]} className="mobile_margin">
            <div className="about">
              <div className="title-section row text-left text-sm-center" data-aos="fade-up" data-aos-duration="1200">
                <h1 className="row-hack">
                  {language === "hu" ? "Miben " : "How can we "}
                  <span>{language === "hu" ? "segíthetünk?" : "help you?"}</span>
                </h1>
                <span className="title-bg">{menuItem[2].menuName}</span>
              </div>
              <div className="container grid-gallery main-content" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                <Services />
              </div>
            </div>
          </Section>

          <Section id={sections[3]} className="mobile_margin">
            <div className="contact">
              <div className="title-section text-left text-sm-center" data-aos="fade-up" data-aos-duration="1200">
                <h1>
                  {language === "hu" ? "Keressen " : "Get in "}
                  <span>{language === "hu" ? "Minket!" : "Touch!"}</span>
                </h1>
                <span className="title-bg">{menuItem[3].menuName}</span>
              </div>
              <div className="container" data-aos="fade-up" data-aos-duration="1200">
                <div className="row">
                  <div className="col-12 col-lg-4">
                    <h3 className="text-uppercase custom-title mb-0 ft-wt-600 pb-3">
                      {language === "hu" ? "KÉRJEN AJÁNLATOT!" : "REQUEST AN OFFER!"}
                    </h3>
                    <p className="open-sans-font mb-4">
                      {language === "hu"
                        ? "Forduljon hozzánk bizalommal! Vegye fel velünk a kapcsolatot az alábbi elérhetőségeken!"
                        : "Feel free to contact us! Get in touch with us through the following channels:"}
                    </p>
                    {language === "hu" ? <Address key="hu-address" /> : <AddressEn key="en-address" />}
                  </div>

                  <div className="col-12 col-lg-8">
                    {language === "hu" ? <Contact key="hu-contact" /> : <ContactEn key="en-contact" />}
                  </div>

                </div>
              </div>
            </div>
          </Section>
        </div>
      </div>
    </ScrollingProvider>
  );
};

export default HomeLight;
